import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TSetProgram } from 'response/CrossroadResponse';

type TWorkNet<T> = {
  isFetching: boolean;
  isFailed: boolean;
  error: string;
  objectData: T;
};

type TCrossroadState = {
  rtsProcessControl: TWorkNet<TSetProgram>;
  rtsReports: TWorkNet<any>;
  rtsReportsDatas: TWorkNet<any>;
  rtsReportsAlls: TWorkNet<any>;
  rtsReportsDiff: TWorkNet<any>;
};

const initialState: TCrossroadState = {
  rtsProcessControl: {
    isFetching: false,
    isFailed: false,
    error: '',
    objectData: {
      oID: '',
      times: '',
    },
  },
  rtsReports: {
    isFetching: false,
    isFailed: false,
    error: '',
    objectData: {
      utime: 0,
    },
  },
  rtsReportsDatas: {
    isFetching: false,
    isFailed: false,
    error: '',
    objectData: {
      utime_start: 0,
      utime_end: 0,
    },
  },
  rtsReportsAlls: {
    isFetching: false,
    isFailed: false,
    error: '',
    objectData: {
      utime_start: 0,
      utime_end: 0,
    },
  },
  rtsReportsDiff: {
    isFetching: false,
    isFailed: false,
    error: '',
    objectData: {
      utime_start: 0,
      utime_end: 0,
      utime_start_two: 0,
      utime_end_two: 0,
    },
  },
};

export const crossroadSlice = createSlice({
  name: 'crossroad',
  initialState,
  reducers: {
    // Start
    crossroadFetchingRTsProcessControl(state) {
      state.rtsProcessControl.isFetching = true;
    },
    crossroadFetchingRTsReports(state) {
      state.rtsReports.isFetching = true;
    },
    crossroadFetchingRTsReportsDatas(state) {
      state.rtsReportsDatas.isFetching = true;
    },
    crossroadFetchingRTsReportsAlls(state) {
      state.rtsReportsAlls.isFetching = true;
    },
    crossroadFetchingRTsReportsDiff(state) {
      state.rtsReportsDiff.isFetching = true;
    },
    // Init
    crossroadFetchingRTsReportsInit(state) {
      state.rtsReports.isFetching = true;
    },
    crossroadFetchingRTsReportsDatasInit(state) {
      state.rtsReportsDatas.isFetching = true;
    },
    crossroadFetchingRTsReportsAllsInit(state) {
      state.rtsReportsAlls.isFetching = true;
    },
    crossroadFetchingRTsReportsDiffInit(state) {
      state.rtsReportsDiff.isFetching = true;
    },
    // Success
    crossroadFetchingRTsProcessControlSuccess(state, action: PayloadAction<TSetProgram>) {
      state.rtsProcessControl.isFetching = false;
      state.rtsProcessControl.isFailed = false;
      state.rtsProcessControl.error = '';
      state.rtsProcessControl.objectData.times = action.payload.times;
    },
    crossroadFetchingRTsReportsSuccess(state, action: PayloadAction<string>) {
      state.rtsReports.isFetching = false;
      state.rtsReports.isFailed = false;
      state.rtsReports.error = '';
      state.rtsReports.objectData = action.payload;
    },
    crossroadFetchingRTsReportsDatasSuccess(state, action: PayloadAction<string>) {
      state.rtsReportsDatas.isFetching = false;
      state.rtsReportsDatas.isFailed = false;
      state.rtsReportsDatas.error = '';
      state.rtsReportsDatas.objectData = action.payload;
    },
    crossroadFetchingRTsReportsAllsSuccess(state, action: PayloadAction<string>) {
      state.rtsReportsAlls.isFetching = false;
      state.rtsReportsAlls.isFailed = false;
      state.rtsReportsAlls.error = '';
      state.rtsReportsAlls.objectData = action.payload;
    },
    crossroadFetchingRTsReportsDiffSuccess(state, action: PayloadAction<string>) {
      state.rtsReportsDiff.isFetching = false;
      state.rtsReportsDiff.isFailed = false;
      state.rtsReportsDiff.error = '';
      state.rtsReportsDiff.objectData = action.payload;
    },
    // Error
    crossroadFetchingRTsProcessControlError(state, action: PayloadAction<string>) {
      state.rtsProcessControl.isFetching = false;
      state.rtsProcessControl.isFailed = true;
      state.rtsProcessControl.error = action.payload;
    },
    crossroadFetchingRTsReportsError(state, action: PayloadAction<string>) {
      state.rtsReports.isFetching = false;
      state.rtsReports.isFailed = true;
      state.rtsReports.error = action.payload;
    },
    crossroadFetchingRTsReportsDatasError(state, action: PayloadAction<string>) {
      state.rtsReportsDatas.isFetching = false;
      state.rtsReportsDatas.isFailed = true;
      state.rtsReportsDatas.error = action.payload;
    },
    crossroadFetchingRTsReportsAllsError(state, action: PayloadAction<string>) {
      state.rtsReportsAlls.isFetching = false;
      state.rtsReportsAlls.isFailed = true;
      state.rtsReportsAlls.error = action.payload;
    },
    crossroadFetchingRTsReportsDiffError(state, action: PayloadAction<string>) {
      state.rtsReportsDiff.isFetching = false;
      state.rtsReportsDiff.isFailed = true;
      state.rtsReportsDiff.error = action.payload;
    },
    // reset state
    rtsReset() {
      return initialState;
    },
  },
});

export default crossroadSlice.reducer;
